// How search reads text: a port of caffeine-viewer's SearchText (and the
// char classes its scorer asks .NET about). Everything here works one UTF-16
// code unit at a time, as C#'s chars do, so matched indices mean the same
// position in both ports.

const UPPER = /\p{Lu}/u
const LOWER = /\p{Ll}/u
const LETTER_OR_DIGIT = /[\p{L}\p{Nd}]/u

const lowerCache = new Map()

// One code unit, lower-cased the way Unity's .NET ToLowerInvariant does: a
// one-to-one mapping. Where JS's toLowerCase returns two units ("İ" ->
// "i̇"), the unit stays as it is -- what the viewer does (Mono leaves U+0130
// alone; the conformance file pins it) -- so the length, and every index
// after it, is kept.
const lowerUnit = c => {
  if (c < 0x80) return c >= 65 && c <= 90 ? c + 32 : c
  if (c >= 0xd800 && c <= 0xdfff) return c
  if (c === 0x2018 || c === 0x2019) return 0x27 // ‘ ’ are apostrophes
  let l = lowerCache.get(c)
  if (l === undefined) {
    const s = String.fromCharCode(c).toLowerCase()
    l = s.length === 1 ? s.charCodeAt(0) : c
    lowerCache.set(c, l)
  }
  return l
}

// SearchText.Lower: lower-cased per code unit (length kept), with ‘ and ’
// folded to the ASCII apostrophe, so "Trevor’s" and "Trevor's" match.
export const lower = text => {
  if (!text) return ''
  let changed = false
  const units = new Array(text.length)
  for (let i = 0; i < text.length; i++) {
    const c = text.charCodeAt(i)
    const l = lowerUnit(c)
    if (l !== c) changed = true
    units[i] = l
  }
  if (!changed) return text
  let out = ''
  for (let i = 0; i < units.length; i += 4096) out += String.fromCharCode.apply(null, units.slice(i, i + 4096))
  return out
}

const classOf = (re, ascii) => ch => {
  if (ch === undefined || ch === null || ch === '') return false
  const c = ch.charCodeAt(0)
  if (c < 0x80) return ascii(c)
  if (c >= 0xd800 && c <= 0xdfff) return false
  return re.test(ch)
}

// char.IsUpper / char.IsLower / char.IsLetterOrDigit on one code unit.
export const isUpper = classOf(UPPER, c => c >= 65 && c <= 90)
export const isLower = classOf(LOWER, c => c >= 97 && c <= 122)
export const isLetterOrDigit = classOf(LETTER_OR_DIGIT, c => (c >= 48 && c <= 57) || (c >= 65 && c <= 90) || (c >= 97 && c <= 122))
